import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Container } from './style';
import { toast } from 'react-toastify';
import { ETrackType, IFaq } from '../../../models/faq.model';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, EditorState } from 'draft-js';
import { useQuery } from '../../../hooks/query';
import _ from 'lodash';
import faqApi from '../../../api/faq.api';
import draftToHtml from 'draftjs-to-html';
import { useParams } from 'react-router-dom';
import { createStateFromHtml } from '../../../utils/draft-js';

const TrackValues = Object.values(ETrackType);

export default function CreateFaqPage() {
  const params = useParams<{ id: string }>();
  const [data, setData] = useState<IFaq>();

  const [answerViState, setAnswerViState] = useState(EditorState.createEmpty());
  const [answerEnState, setAnswerEnState] = useState(EditorState.createEmpty());

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    faqApi
      .getDetail(params.id!)
      .then((res) => {
        setData(res.data);

        setAnswerViState(createStateFromHtml(res.data.answer_vi));
        setAnswerEnState(createStateFromHtml(res.data.answer_en));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params.id]);

  return (
    <Container>
      <Box
        sx={{
          width: '100%',
          p: 2,
          boxSizing: 'border-box',
        }}
      >
        <Grid container columnSpacing={2} rowSpacing={4}>
          <Grid item xs={12}>
            <Typography variant="h3" p={1}>
              Update new FAQ
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <TextField
              sx={{ mt: 1 }}
              label="Index"
              variant="outlined"
              size="small"
              type="number"
              inputProps={{
                min: 1,
              }}
              value={data?.weight || 1}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    weight: +(ev.currentTarget.value || 1),
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" fullWidth>
              <InputLabel id="demo-select-small-label">Track</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                disabled
                value={data?.track || ETrackType.Startup}
                label="Age"
                onChange={(ev) => {}}
              >
                {TrackValues.map((value) => (
                  <MenuItem value={value} key={value}>
                    {_.words(value).join(' ')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Question
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              value={data?.question_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    question_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              value={data?.question_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    question_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Answer
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography p={1} mb={1}>
              Vietnamese
            </Typography>

            <Editor
              editorState={answerViState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="draft-editor content"
              onEditorStateChange={setAnswerViState}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography p={1} mb={1}>
              English
            </Typography>
            <Editor
              editorState={answerEnState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="draft-editor content"
              onEditorStateChange={setAnswerEnState}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              disabled={loading || !data}
              sx={{ minWidth: 200 }}
              variant="contained"
              onClick={() => {
                if (data) {
                  const answer_vi = draftToHtml(
                    convertToRaw(answerViState.getCurrentContent()),
                  );
                  const answer_en = draftToHtml(
                    convertToRaw(answerEnState.getCurrentContent()),
                  );
                  setLoading(true);
                  faqApi
                    .create({
                      ...data,
                      answer_en,
                      answer_vi,
                    })
                    .then((res) => {
                      toast.success('Update successful');
                      setData(res.data);
                    })
                    .then((res) => {})
                    .finally(() => {
                      setLoading(false);
                    });
                }
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <div style={{ height: 100 }} />
      </Box>
    </Container>
  );
}
